<h5s-istat-header />
<h5s-istat-filter (filterChange)="filters.set($event)" />
<h5s-istat-table [filters]="filters()" />
